import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { environment } from 'src/environments/environment';

export interface EventAttachmentVM{
  FileName: string;
  GUID: string;
  MimeType?: string;
  Length?: number;
}

@Component({
  selector: 'app-event-attachments',
  standalone: true,
  imports: [CommonModule, ButtonModule, ConfirmPopupModule],
  templateUrl: './event-attachments.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './event-attachments.component.scss'
})
export class EventAttachmentsComponent {
  @Input() attachments: EventAttachmentVM[] = [];
  @Input() uploading: boolean = false;
  @Input() errorMessage: string = '';

  @Output() uploadFile = new EventEmitter<File>();
  @Output() downloadFile = new EventEmitter<string>();
  @Output() removeFile = new EventEmitter<{ guid: string; event: Event }>();

  onAttachmentSelected(event: Event){
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files.length ? input.files[0] : null;
    if (file){
      this.uploadFile.emit(file);
    }
    if (input){
      input.value = '';
    }
  }

  onDownload(guid: string){
    this.downloadFile.emit(guid);
  }

  onRemove(guid: string, event: Event){
    this.removeFile.emit({ guid, event });
  }

  isImage(att: EventAttachmentVM): boolean{
    const mime = (att?.MimeType || '').toLowerCase();
    if (mime.startsWith('image/')){
      return true;
    }
    const name = (att?.FileName || '').toLowerCase();
    return /\.(png|jpe?g|gif|bmp|webp|svg)$/.test(name);
  }

  attachmentSrc(guid: string): string{
    return `${environment.apiUrl}events/attachments/${guid}`;
  }
}
